import { Injectable } from '@angular/core';
import { QualificationTrainings } from '@wilson/interfaces';
import { ReplaySubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TrainingQualificationsBulkEditDrawerService {
  private _trainingsToEdit = new ReplaySubject<QualificationTrainings[]>(1);
  private _bulkEditDrawerVisible = new ReplaySubject<boolean>(1);
  private _bulkEditedTrainings = new Subject<void>();

  public trainingsToEdit$ = this._trainingsToEdit.asObservable();
  public bulkEditDrawerVisible$ = this._bulkEditDrawerVisible.asObservable();
  public bulkEditedTrainings$ = this._bulkEditedTrainings.asObservable();

  public setTrainingsToEdit(trainings: QualificationTrainings[]): void {
    this._trainingsToEdit.next(trainings);
  }

  public setBulkEditDrawerVisible(visible: boolean): void {
    this._bulkEditDrawerVisible.next(visible);
  }

  public triggerBulkEditedTrainings(): void {
    this._bulkEditedTrainings.next();
  }
}
